<div *ngIf="!isEmailScreen" class="{{styledClass}}">
  <div class="modal-wrapper">
    <h1 class="margin-bottom-16 text-dark-blue title">{{appCopy.zeroTimeSlot['upsellTitle'+selectedLanguage]}}</h1>
    <p class='content'>{{appCopy.zeroTimeSlot['upsellContent'+selectedLanguage].replace('%s', arrivalAirportCityName)}}</p>
    <div class="card">
      <div class="card-body">
        <div class="details" [ngStyle]="{order: upsellbookingStatus.currentBooking === 'abc' ? 0 : 2}">
          <b>{{airlineCode}}</b>
          <p>{{flightDirection === 1 ? arrivalAirportCode : departureAirportCode}} {{appCopy.zeroTimeSlot[flightDirection === 1 ? 'arrival'+selectedLanguage : 'departure'+selectedLanguage]}}</p>
        </div>
        <div class="center-image" style='order: 1'>
          <img [src]="upsellbookingStatus.currentBooking === 'abc' ? 'images/carousel.svg' : 'images/car.svg'" alt="upsell service image">
        </div>
        <div class="details" [ngStyle]="{order: upsellbookingStatus.currentBooking === 'abc' ? 2 : 0}">
          <b>{{appCopy.zeroTimeSlot['yourAddress'+selectedLanguage]}}</b>
          <p>{{appCopy.zeroTimeSlot['homeHotelOffice'+selectedLanguage]}}</p>
        </div>
      </div>
    </div>
    <div class='pill-primary'>
      <p class='text'>{{appCopy.zeroTimeSlot['pricePill'+selectedLanguage].replace('%s', startPrice)}}</p>
    </div>
  </div>

  <div class="action-btn">
    <button id="formBagPickupTimeDate-submit" type="button" style="background-color: #7850FA;color: white;"
      class="btn btn-block margin-bottom-24" (click)="makeUpsellBooking()">
      {{appCopy.zeroTimeSlot['findMore'+selectedLanguage]}}
    </button>
    <button id="formBagPickupTimeDate-submit" type="button"
      style="background-color: transparent;color: #7850FA;border: solid 1px #7850FA;"
      class="btn btn-block margin-bottom-24" (click)="gotoHome()">
      {{appCopy.zeroTimeSlot['homeLink'+selectedLanguage]}}
    </button>
  </div>
</div>
<!-- Email screen -->
<div *ngIf="isEmailScreen" class="{{styledClass}}">
  <form name="noTimesloteConsentForm" ng novalidate #form="ngForm">
  <div class="modal-wrapper">
    <img class='no-service-img' src="images/no-service.svg" alt="no service available" >
    <h1 class="margin-bottom-16 text-dark-blue title">{{appCopy.zeroTimeSlot['zeroPickupSlot'+selectedLanguage]}}</h1>
    <p class='content' [innerHTML]="appCopy.zeroTimeSlot['contsent'+selectedLanguage]"></p>
    <div class="email" style="display: none;">
      <div>
        <input
        [placeholder]="appCopy.zeroTimeSlot['emailPlaceholder'+selectedLanguage]"
        [ngClass]="{ 'has-error' : bookerEmail.dirty && bookerEmail.invalid || bookerEmail.dirty && bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect }"
        id="bookerEmail" name="bookerEmail" type="email" #bookerEmail="ngModel"
        (ngModel)="userData.bookerEmail" [pattern]="emailPattern" autocomplete="off" >

        <p class="help-block text-danger" *ngIf="bookerEmail.dirty && bookerEmail.errors?.pattern">
        {{appCopy.zeroTimeSlot['errorTextBookerEmailInvalid'+selectedLanguage]}}</p>
      </div>
    </div>
  </div>
  <div class="action-btn">
    <button *ngIf="canPay" id="formBagPickupTimeDate-submit" type="button" style="background-color: #7850FA;color: white;"
    class="btn btn-block margin-bottom-24" [disabled]="bookerEmail.value && bookerEmail.dirty && bookerEmail.invalid" (click)="goForPayment(bookerEmail.value)">
    {{appCopy.zeroTimeSlot['paymentBtn'+selectedLanguage]}}
    </button>

    <button *ngIf="!canPay" id="formBagPickupTimeDate-submit" type="button" style="background-color: #7850FA;color: white;"
    class="btn btn-block margin-bottom-24" [disabled]="bookerEmail.value && bookerEmail.dirty && bookerEmail.invalid" (click)="gotoHome(bookerEmail.value)">
    {{appCopy.zeroTimeSlot['goBack'+selectedLanguage]}}
    </button>
  </div>
  </form>
</div>
